import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthStore } from '@core/auth/auth.store';
import { LoadingComponent } from '@shared/components/loading/loading.component';

@Component({
  imports: [LoadingComponent, RouterOutlet],
  selector: 'nexo-root',
  styleUrl: './app.css',
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly authStore = inject(AuthStore);
}
